import { render, staticRenderFns } from "./List.vue?vue&type=template&id=5a3c1064&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=5a3c1064&prod&lang=scss"
import style1 from "./List.vue?vue&type=style&index=1&id=5a3c1064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3c1064",
  null
  
)

export default component.exports